// extracted by mini-css-extract-plugin
export default {"tasks":"sN-z","task":"tN-z","svg":"uN-z","text":"vN-z"};